import { levelEntry } from "../campaign/entrypoint.ts";

export const entrypoints = [levelEntry("conjunto", () => import("./view.tsx"))];
